import React from 'react'
import {
  Box,
  TextV2 as Text,
  Flex,
  Colors,
} from '@pinchenterprisesnpm/friday-ui'
import { CustomValidationError } from '@src/features/shift-post-v2/style'

interface IWeekdaySelectorProps {
  selectedDays: string[]
  onDayToggle: (day: string) => void
  error?: string | string[]
  isDisabled?: boolean
}

const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

const CalendarDay = ({
  children,
  isSelected,
  onClick,
  isDisabled,
}: {
  children: React.ReactNode
  isSelected: boolean
  onClick: () => void
  isDisabled?: boolean
}) => (
  <button
    type="button"
    disabled={isDisabled}
    onClick={onClick}
    style={{
      width: '35px',
      height: '35px',
      borderRadius: '4px',
      border: `1px solid ${Colors.primary_500}`,
      backgroundColor: isSelected ? Colors.primary_500 : 'transparent',
      color: isSelected ? Colors.white : Colors.primary_500,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: '500',
      marginRight: '4px',
      opacity: isDisabled ? 0.5 : 1,
      pointerEvents: isDisabled ? 'none' : 'auto',
    }}
  >
    {children}
  </button>
)

export const WeekdaySelector = ({
  selectedDays,
  onDayToggle,
  error,
  isDisabled,
}: IWeekdaySelectorProps) => {
  return (
    <Box mb="sm">
      <Text mb="xs" variant="small">
        Repeat on
      </Text>
      <Flex>
        {weekdays.map((day, index) => (
          <CalendarDay
            key={index}
            onClick={() => onDayToggle(day)}
            isSelected={selectedDays.includes(day)}
            isDisabled={isDisabled}
          >
            {day}
          </CalendarDay>
        ))}
      </Flex>

      {error && (
        <CustomValidationError mt="xs" mb={0}>
          {error}
        </CustomValidationError>
      )}
    </Box>
  )
}

export default WeekdaySelector
